import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface SiteSavingData {
  message?: string;
}

@Component({
  selector: 'app-site-saving-dialog',
  templateUrl: './site-saving-dialog.component.html',
  styleUrls: ['./site-saving-dialog.component.css'],
  standalone: false
})
export class SiteSavingDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SiteSavingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SiteSavingData,
    private router: Router
  ) {}

  onWait(): void {
    // Keep the dialog open - do nothing
    // The dialog will remain visible
  }

  onHome(): void {
    // Navigate to home screen
    this.router.navigate(['/']).then(() => {
      this.dialogRef.close('home');
    });
  }
}

